import {
	arrayToDisplayWith,
	codableConceptCodeToDisplayWith,
	codeToDisplayFromValueSetBundle,
	dataValueOrAbsentCodeToDisplayWith,
} from "@intocare/datatypes/lib/display";
import { SupportedLocale } from "@intocare/datatypes/lib/i18n";
import { OBSERVATION_CAUSE_ABSENT_REASON_DISPLAY } from "@intocare/terminology/lib/value-set/display/observation-cause-absent-reason.display";
import { OBSERVATION_CAUSE_DISPLAY } from "@intocare/terminology/lib/value-set/display/observation-cause.display";
import { OBSERVATION_CONSEQUENCE_DISPLAY } from "@intocare/terminology/lib/value-set/display/observation-consequence.display";
import { OBSERVATION_CONTEXT_ABSENT_REASON_DISPLAY } from "@intocare/terminology/lib/value-set/display/observation-context-absent-reason.display";
import { OBSERVATION_CONTEXT_DISPLAY } from "@intocare/terminology/lib/value-set/display/observation-context.display";
import { OBSERVATION_CORRECTIVE_ACTION_DISPLAY } from "@intocare/terminology/lib/value-set/display/observation-corrective-action.display";
import { OBSERVATION_LOCATION_DISPLAY } from "@intocare/terminology/lib/value-set/display/observation-location.display";
import { OBSERVATION_TYPE_DISPLAY } from "@intocare/terminology/lib/value-set/display/observation-type.display";
import { PART_OF_DAY_DISPLAY } from "@intocare/terminology/lib/value-set/display/part-of-day.display";

export const shortTime = {
	hour: "2-digit",
	minute: "2-digit",
} as const;

export const observationToDisplay = {
	type(typeCode: string, locale: SupportedLocale) {
		return codeToDisplayFromValueSetBundle(OBSERVATION_TYPE_DISPLAY)(typeCode, locale);
	},
	observedOn(datetime: string, locale: SupportedLocale) {
		const date = new Date(datetime);
		return `${date.toLocaleDateString(locale)} - ${date.toLocaleTimeString(locale, shortTime)}`;
	},
	occurredOn(occurredOn: { date: string; partOfDay: { code: string } }, locale: SupportedLocale) {
		return `${new Date(occurredOn.date).toLocaleDateString(locale)} - ${codeToDisplayFromValueSetBundle(
			PART_OF_DAY_DISPLAY,
		)(occurredOn.partOfDay.code, locale)}`;
	},
};

export const fallToDisplay = {
	location: codableConceptCodeToDisplayWith(codeToDisplayFromValueSetBundle(OBSERVATION_LOCATION_DISPLAY)),
	contexts: dataValueOrAbsentCodeToDisplayWith({
		absentCodeToDisplay: codeToDisplayFromValueSetBundle(OBSERVATION_CONTEXT_ABSENT_REASON_DISPLAY),
		valueToDisplay: arrayToDisplayWith(
			codableConceptCodeToDisplayWith(codeToDisplayFromValueSetBundle(OBSERVATION_CONTEXT_DISPLAY)),
		),
	}),
	causes: dataValueOrAbsentCodeToDisplayWith({
		absentCodeToDisplay: codeToDisplayFromValueSetBundle(OBSERVATION_CAUSE_ABSENT_REASON_DISPLAY),
		valueToDisplay: arrayToDisplayWith(
			codableConceptCodeToDisplayWith(codeToDisplayFromValueSetBundle(OBSERVATION_CAUSE_DISPLAY)),
		),
	}),
	consequences: arrayToDisplayWith(
		codableConceptCodeToDisplayWith(codeToDisplayFromValueSetBundle(OBSERVATION_CONSEQUENCE_DISPLAY)),
	),
	correctiveActions: arrayToDisplayWith(
		codableConceptCodeToDisplayWith(codeToDisplayFromValueSetBundle(OBSERVATION_CORRECTIVE_ACTION_DISPLAY)),
	),
} as const;
